const config = require('../config');
const apiFactory = require('../resources/reset-code/api-factory');
const serviceFactory = require('../resources/reset-code/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/globalauth/1.0/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`resetcode.requestResetCode[{keys:username}][{keys:email}][{keys:platform}][{keys:langCode}][{keys:dummy}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.requestResetCode(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`resetcode.verifyResetCode[{keys:resetCodeId}][{keys:resetCodeValue}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.verifyResetCode(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`resetcode.verifyResetCode[{keys:resetCodeId}][{keys:resetCodeValue}][{keys:channel}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.verifyResetCodeExtended(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`resetcode.resendResetCode[{keys:resetCodeId}][{keys:langCode}][{keys:dummy}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.resendResetCode(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}resetcode.changePassword[{keys:token}][{keys:userId}][{keys:newCryptoPassword}][{keys:langCode}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.changePassword(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
}

module.exports = addRoutes;
